export default {
  layout: {
    backToHome: '홈으로 돌아가기',
    legalDocuments: '법률 문서',
    product: '제품',
    developers: '개발자',
    company: '회사',
    legal: '법률',
  },
  nav: {
    markets: '마켓',
    aiAgents: 'AI 에이전트',
    vaults: '볼트',
    leaderboard: '리더보드',
    fees: '수수료',
    apiReference: 'API 레퍼런스',
    sdks: 'SDK',
    about: 'ZhiSu 소개',
    careers: '채용',
    contact: '문의하기',
    press: '프레스 및 미디어',
    brand: '브랜드 가이드라인',
    terms: '서비스 약관',
    privacy: '개인정보 처리방침',
    cookies: '쿠키 정책',
    aml: 'AML 정책',
    risk: '위험 고지',
    agreement: '사용자 계약',
    skills: '스킬',
  },
  table: {
    pair: '페어',
    price: '가격',
    change24h: '24h 변동',
    volume24h: '24h 거래량',
    funding: '펀딩 비율',
    high24h: '24h 최고',
    low24h: '24h 최저',
    rank: '순위',
    trader: '트레이더',
    pnl30d: '30일 손익',
    winRate: '승률',
    method: '메소드',
    endpoint: '엔드포인트',
    description: '설명',
    auth: '인증',
    required: '필수',
    none: '없음',
    trades: '거래 횟수',
    volume: '거래량',
    followers: '팔로워',
  },
  common: {
    lastUpdated: '마지막 업데이트',
  },
  markets: {
    title: '마켓',
    subtitle: '50개 이상의 암호화폐 페어에서 영구 선물을 최대 50배 레버리지로 거래',
  },
  aiAgents: {
    title: 'AI 에이전트',
    subtitle: '머신러닝 전략을 탑재한 자율 AI 거래 에이전트를 배포',
    pnl30d: '30일 손익',
    winRate: '승률',
    trades24h: '24h 거래 횟수',
    risk: '위험도',
    avgHold: '평균 보유',
  },
  vaults: {
    title: '볼트',
    subtitle: '내장 리스크 관리가 있는 자동화 수익 전략 볼트',
    tvl: '총 예치 가치',
    apy: '연간 수익률',
    depositors: '예치자 수',
    minDeposit: '최소 예치금',
    riskLevel: '위험 수준',
    low: '낮음',
    medium: '중간',
    high: '높음',
  },
  leaderboard: {
    title: '리더보드',
    subtitle: '30일 손익 기준 상위 트레이더 순위',
    allTime: '전체 기간',
    weekly: '주간',
  },
  fees: {
    title: '수수료',
    subtitle: '모든 트레이더를 위한 투명하고 경쟁력 있는 수수료 구조',
    tier: '등급',
    maker: '메이커',
    taker: '테이커',
    volume30d: '30일 거래량',
    holderRequirement: 'HOLDER 보유 요건',
    fundingRate: '펀딩 비율',
    fundingLong: '양수일 때 롱이 숏에게 지불',
    fundingShort: '음수일 때 숏이 롱에게 지불',
    withdrawalFees: '출금 수수료',
    asset: '자산',
    networkFee: '네트워크 수수료',
    minWithdrawal: '최소 출금액',
    perpetualTrading: '퍼페추얼 거래',
    interval: '간격',
    settlement: '정산',
    maxRate: '최대 비율',
  },
  apiReference: {
    title: 'API 레퍼런스',
    subtitle: '시장 데이터, 거래, 계정 관리를 위한 완전한 REST API 문서',
    baseUrl: '기본 URL',
    authentication: '인증',
    authDesc: '공개 엔드포인트는 인증이 필요 없습니다. 인증이 필요한 엔드포인트는 X-API-Key 헤더에 API 키를 전달해야 합니다.',
    rateLimits: '속도 제한',
    public: '공개',
    authenticated: '인증됨',
    websocket: 'WebSocket',
    epMarkets: '이용 가능한 모든 거래 시장 목록',
    epTicker: '특정 시장의 24시간 티커 데이터 가져오기',
    epOrderbook: '특정 시장의 오더북 깊이 가져오기',
    epTrades: '특정 시장의 최근 거래 가져오기',
    epAccount: '계정 잔액 및 포지션 가져오기',
    epOrders: '새 주문 생성',
    epCancelOrder: '기존 주문 취소',
    epOrdersList: '활성 주문 목록',
    epFills: '역사적 체결 기록 가져오기',
    epFundingRates: '모든 시장의 현재 자금 조달률 가져오기',
  },
  sdks: {
    title: 'SDK',
    subtitle: 'Python, TypeScript, Rust, Go 공식 SDK',
    install: '설치',
    documentation: '문서',
    pythonDesc: 'REST API 및 WebSocket 스트리밍을 위한 풀기능 Python 클라이언트. async/await, 타입 힌트 및 자동 재연결 지원.',
    tsDesc: '완전한 타입 안전성, 내장 재시도 로직, 브라우저/Node.js 호환성을 갖춘 현대적인 TypeScript/JavaScript 클라이언트.',
    rustDesc: '저지연 거래 봇 및 정량적 전략을 위해 최적화된 고성능 Rust 클라이언트.',
    goDesc: '동시 WebSocket 지원 및 효율적인 메모리 관리를 갖춘 경량 Go 클라이언트. 고빈도 애플리케이션용.',
  },
  about: {
    title: 'ZhiSu 소개',
    subtitle: '탈중앙화 파생상품 거래의 미래를 구축합니다',
    ourValues: '우리의 가치',
    leadershipTeam: '리더십 팀',
    backedBy: '투자자',
    decentralization: '탈중앙화',
    decentralizationDesc: '우리는 중개인 없이 금융 시장이 작동하는 세상을 믿습니다. ZhiSu의 모든 거래는 온체인에서 결제되어 사용자가 항상 자산을 완전히 통제할 수 있습니다.',
    innovation: '혁신',
    innovationDesc: '우리는 DeFi에서 가능한 것의 한계를 뛰어넘습니다. AI 기반 거래 에이전트부터 크로스체인 유동성 집계까지, 차세대 금융을 위한 인프라를 구축하고 있습니다.',
    transparency: '투명성',
    transparencyDesc: '모든 프로토콜 운영, 수수료 구조, 거버넌스 결정은 공개되어 감사 가능합니다. 스마트 컨트랙트는 공개 검증되었으며 로드맵은 커뮤니티와 공유됩니다.',
    security: '보안',
    securityDesc: '보안은 사후 고려 사항이 아닙니다. 우리 코드는 여러 차례의 독립적인 감사를 받으며, 사용자 자금의 안전을 보장하기 위한 포괄적인 버그 바운티 프로그램을 운영합니다.',
    founded: '2024년에 설립된 ZhiSu은 최첨단 블록체인 인프라 위에 구축된 차세대 탈중앙화 파생상품 거래소입니다.',
    volume: '누적 거래량 28억 달러 이상과 지속적으로 성장하는 AI 기반 거래 에이전트 생태계를 보유한 ZhiSu은 DeFi 분야에서 가장 신뢰할 수 있는 플랫폼 중 하나가 되었습니다.',
    teamDesc: '우리 팀은 최고의 정량적 헤지펀드, 전통 금융 기관, 최상위 블록체인 프로토콜의 전문성을 결집합니다.',
    totalVolume: '총 거래량',
    activeTraders: '활성 트레이더',
    markets: '마켓 수',
    countries: '서비스 국가',
    ceo: '최고경영자',
    cto: '최고기술책임자',
    headProduct: '제품 책임자',
    headAI: 'AI 연구 책임자',
    clo: '최고법무책임자',
    headEng: '엔지니어링 책임자',
  },
  careers: {
    title: '채용',
    subtitle: 'AI 네이티브 거래 인프라를 구축하는 팀에 합류하세요',
    openPositions: '채용 중인 포지션',
    allDepartments: '모든 부서',
    engineering: '엔지니어링',
    product: '제품',
    design: '디자인',
    marketing: '마케팅',
    operations: '운영',
    legal: '법무',
    location: '근무지',
    type: '유형',
    applyNow: '지금 지원',
    benefits: 'ZhiSu에서 일하는 이유',
    benefit1Title: '경쟁력 있는 보상',
    benefit1Desc: '시장 평균 이상의 급여, 토큰 할당 및 성과 보너스.',
    benefit2Title: '원격 우선',
    benefit2Desc: '어디서나 근무 가능합니다. 우리는 전 세계에 분산된 팀입니다.',
    benefit3Title: '최첨단 기술',
    benefit3Desc: 'AI, 블록체인 및 분산 시스템의 최신 기술로 구축합니다.',
    benefit4Title: '성장',
    benefit4Desc: '빠르게 성장하는 산업에서 빠른 경력 발전.',
  },
  contact: {
    title: '문의하기',
    subtitle: '우리 팀과 연락하세요',
    generalInquiries: '일반 문의',
    support: '지원',
    press: '프레스',
    partnerships: '파트너십',
    sendMessage: '메시지 보내기',
    name: '이름',
    email: '이메일',
    subject: '제목',
    message: '메시지',
    followUs: '팔로우하기',
    response: '보통 24시간 이내에 회신합니다.',
  },
  press: {
    title: '프레스 및 미디어',
    subtitle: 'ZhiSu의 최신 뉴스 및 공지',
    mediaContact: '미디어 연락처',
    pressEmail: 'press@zhisu.trade',
    readMore: '더 읽기',
  },
  brand: {
    title: '브랜드 가이드라인',
    subtitle: '공식 브랜드 에셋 및 사용 가이드라인',
    logoUsage: '로고 사용',
    colorPalette: '색상 팔레트',
    typography: '타이포그래피',
    do: '가능',
    dont: '불가능',
    primary: '주요 색상',
    secondary: '보조 색상',
    background: '배경색',
    accent: '강조색',
    headingFont: '제목 폰트',
    bodyFont: '본문 폰트',
    monoFont: '고정폭 폰트',
    logoRules1: '충분한 대비를 가진 어두운 또는 밝은 배경 위에서 로고를 사용하세요.',
    logoRules2: '로고 주변에 V 마크 높이와 동일한 여백을 확보하세요.',
    logoRules3: '다른 배경에 대해 제공된 색상 변형을 사용하세요.',
  },
  terms: {
    title: '서비스 약관',
    s1: '1. 서비스 약관 동의',
    s2: '2. 자격',
    s3: '3. 서비스 설명',
    s4: '4. 계정 등록 및 보안',
    s5: '5. 거래 규칙 및 위험',
    s6: '6. 수수료 및 요금',
    s7: '7. 금지 활동',
    s8: '8. 지식재산권',
    s9: '9. 보증 부인',
    s10: '10. 책임 제한',
    s11: '11. 배상',
    s12: '12. 준거법 및 분쟁 해결',
    s13: '13. 약관 개정',
    s14: '14. 연락처',
  },
  privacy: {
    title: '개인정보 처리방침',
    s1: '1. 소개',
    s2: '2. 수집하는 정보',
    s3: '3. 정보 사용 방법',
    s4: '4. 처리의 법적 근거',
    s5: '5. 정보 공유 및 공개',
    s6: '6. 데이터 보안',
    s7: '7. 데이터 보관',
    s8: '8. 귀하의 권리',
    s9: '9. 국제 데이터 전송',
    s10: '10. 아동 개인정보',
    s11: '11. 정책 변경',
    s12: '12. 문의하기',
  },
  cookies: {
    title: '쿠키 정책',
    s1: '1. 쿠키란 무엇인가',
    s2: '2. 쿠키 사용 방법',
    s3: '3. 사용하는 쿠키 유형',
    s4: '4. 제3자 쿠키',
    s5: '5. 쿠키 설정 관리',
    s6: '6. 웹 비콘 및 유사 기술',
    s7: '7. 추적 금지 신호',
    s8: '8. 정책 변경',
    s9: '9. 문의하기',
  },
  aml: {
    title: 'AML 정책',
    s1: '1. 정책 성명',
    s2: '2. 규제 프레임워크',
    s3: '3. 고객 실사(CDD)',
    s4: '4. 지속적 모니터링',
    s5: '5. 금지 활동',
    s6: '6. 제재 준수',
    s7: '7. 의심 활동 신고',
    s8: '8. 기록 보관',
    s9: '9. 직원 교육',
    s10: '10. 독립 감사',
    s11: '11. 문의하기',
  },
  risk: {
    title: '위험 고지',
    s1: '1. 중요 공지',
    s2: '2. 재무 자문 아님',
    s3: '3. 시장 위험',
    s4: '4. 레버리지 및 마진 위험',
    s5: '5. 스마트 계약 및 기술 위험',
    s6: '6. AI 에이전트 및 자동 거래 위험',
    s7: '7. 자산 보관 및 지갑 위험',
    s8: '8. 규제 및 준수 위험',
    s9: '9. 사이버 보안 위험',
    s10: '10. 전액 손실 위험',
    s11: '11. 플랫폼 가용성 보장 없음',
    s12: '12. 승인',
    s13: '13. 문의하기',
  },
  agreement: {
    title: '사용자 계약',
    s1: '1. 계약 개요',
    s2: '2. 정의',
    s3: '3. 계정 및 지갑 연결',
    s4: '4. 거래 규칙',
    s5: '5. 수수료 및 결제',
    s6: '6. AI 에이전트 및 자동화 서비스',
    s7: '7. API 사용',
    s8: '8. 진술 및 보증',
    s9: '9. 해지',
    s10: '10. 분쟁 해결',
    s11: '11. 변경',
    s12: '12. 완전 합의',
    s13: '13. 문의하기',
  },
  skills: {
    title: '스킬',
    subtitle: '커뮤니티가 만든 AI 에이전트 스킬을 발견하고 설치하세요',
    searchPlaceholder: '무엇을 찾고 있나요?',
    install: '설치',
    installNow: '설치',
    categories: {
      all: '전체',
      defi: 'DeFi 및 거래',
      social: '소셜 및 메시징',
      tools: '분석 및 도구',
      other: '기타',
    },
    stats: {
      tools: '도구',
      users: '사용자',
      downloads: '다운로드',
      rating: '평균 평점',
    },
    featuredSkills: '추천 스킬',
    trendingNow: '인기 트렌드',
    viewAll: '모두 보기',
    allSkills: '모든 스킬',
    searchResults: '검색 결과',
    noResults: '검색 조건에 맞는 스킬을 찾을 수 없습니다.',
    builtByCommunity: '커뮤니티가 만든',
    equip: '장착',
    unleash: '해제',
    toolsReady: '수천 명의 개발자가 만든 도구를 검색 하나로 사용 가능합니다.',
    installCommand: '설치 명령어',
    copied: '복사 완료!',
    copy: '복사',
    about: '소개',
    usageExample: '사용 예시',
    info: '정보',
    related: '관련 스킬',
    backToSkills: '스킬 목록으로',
    notFound: '스킬을 찾을 수 없습니다',
    notFoundDesc: '찾으시는 스킬이 존재하지 않습니다.',
  },
};